<template>
  <AuthLayout compact>
    <!-- Procesando el callback -->
    <div v-if="processing" class="state">
      <i class="pi pi-spin pi-spinner spinner-icon" aria-hidden="true" />
      <p>Iniciando sesión...</p>
    </div>

    <!-- Error del proveedor -->
    <div v-else-if="error" class="state">
      <i class="pi pi-times-circle state-icon" aria-hidden="true" />
      <p class="state-error">{{ errorMessage }}</p>
      <Button label="Volver al login" icon="pi pi-sign-in" @click="$router.push('/login')" />
    </div>
  </AuthLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import Button from 'primevue/button';
import AuthLayout from '../components/layout/AuthLayout.vue';
import api from '../services/api';

const router = useRouter();
const authStore = useAuthStore();
const processing = ref(true);
const error = ref(false);
const errorMessage = ref('');

const errorMessages = {
  access_denied: 'Acceso denegado. Cancelaste el inicio de sesión.',
  no_email: 'No se pudo obtener tu email del proveedor.',
  server_error: 'Error del servidor. Intenta de nuevo.',
};

onMounted(async () => {
  // El token llega en el fragment: /oauth/callback#token=XXX
  const hash = window.location.hash.slice(1);
  const params = new URLSearchParams(hash);
  const token = params.get('token');
  const refreshToken = params.get('refresh_token');

  // O puede llegar un error en query params
  const queryParams = new URLSearchParams(window.location.search);
  const oauthError = queryParams.get('oauth_error');

  if (oauthError) {
    error.value = true;
    errorMessage.value = errorMessages[oauthError] || `Error: ${oauthError}`;
    processing.value = false;
    return;
  }

  if (!token) {
    error.value = true;
    errorMessage.value = 'No se recibió el token de autenticación.';
    processing.value = false;
    return;
  }

  try {
    // Guardar el token y cargar el perfil del usuario
    authStore.setToken(token);
    authStore.setRefreshToken(refreshToken);
    const userRes = await api.get('/auth/users/me');
    authStore.setUser(userRes.data);
    const permRes = await api.get('/auth/users/me/permissions');
    authStore.setPermissions(permRes.data.permissions);
    router.push('/');
  } catch (e) {
    error.value = true;
    errorMessage.value = 'Error al cargar tu perfil. Intenta de nuevo.';
    processing.value = false;
  }
});
</script>

<style scoped>
.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.state p {
  color: #6b7280;
  margin: 0;
}

.spinner-icon {
  font-size: 2.5rem;
  color: #6366f1;
}

.state-icon {
  font-size: 2.5rem;
  color: #ef4444;
}

.state-error {
  color: #ef4444 !important;
}
</style>
